/**
 * Stack-Auth-Client (Neon Auth = Stack Auth).
 *
 * Paket: @stackframe/react (React-SDK fuer Vite/CRA, nicht die Next.js-Variante @stackframe/stack).
 * Quelle: https://www.npmjs.com/package/@stackframe/react  /  https://docs.stack-auth.com
 *
 * OFFENER PUNKT (gegen echte Infra verifizieren): exakter SDK-Paketname/-Version und die
 * `urls`-Keys. Siehe README -> OFFENE PUNKTE.
 */
import { StackClientApp } from "@stackframe/react";

export const stackApp = new StackClientApp({
  projectId: import.meta.env.VITE_STACK_PROJECT_ID,
  publishableClientKey: import.meta.env.VITE_STACK_PUBLISHABLE_CLIENT_KEY,
  // "cookie" -> Tokens im Browser-Cookie (Standard fuer SPA ohne Next.js).
  tokenStore: "cookie",
  urls: {
    // Basis-Route, unter der <StackHandler> die Auth-Seiten rendert (siehe App.tsx).
    handler: "/handler",
    // Entscheidung 2 (26.09.2026): die eigene Anmeldeseite statt Stacks Standardseite (die jeden
    // im Projekt aktiven OAuth-Anbieter zeigt, auch GitHub). /handler/sign-in leitet dorthin um.
    signIn: "/login",
    signUp: "/handler/sign-up",
    afterSignIn: "/",
    afterSignUp: "/",
    afterSignOut: "/login",
  },
});
